import { BloxCertificate } from './BloxCertificate'
import { bloxDetail } from './detail'
import { bloxOfferings } from './offerings'
import { bloxOfferingsByID } from './offeringsByID'
import { ValidateCertificate } from './ValidateCertificate'

export default {
  bloxDetail,
  bloxOfferings,
  bloxOfferingsByID,
  ValidateCertificate,
  BloxCertificate,
}
